<div class="fx-layout-row fx-layout-align-center-center">
  <div class=" fx-flex-80pc">
    <div class="row">
      <button type="button" pButton label="Export
      to Excel" (click)="dt.exportCSV()" style="float:left"></button>
    </div>
    <p-table #dt [columns]="cols" [value]="members" [paginator]="true" selectionMode="single" [rows]="rows"
      [totalRecords]="totalRecords" [loading]="loading" [lazy]="true" (onLazyLoad)="loadRegmemLazy($event)"
      (onRowSelect)="onRowSelect($event)">
      <!-- <ng-template pTemplate="caption">
          <div style="text-align: right">
            <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
            <input type="text" pInputText class="margin0"  size="50" placeholder="Global Filter"
              (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">
          </div>
        </ng-template> -->
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field">
            {{col.header}}
            <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
              ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order">
            </p-sortIcon>
          </th>
        </tr>
        <tr>
          <th *ngFor="let col of columns" [ngSwitch]="col.field">
            <input *ngSwitchCase="'membername'" pInputText type="text"
              (input)="dt.filter($event.target.value, col.field, 'contains')">
            <input *ngSwitchCase="'fname'" pInputText type="text"
              (input)="dt.filter($event.target.value, col.field, 'contains')">
            <input *ngSwitchCase="'lname'" pInputText type="text"
              (input)="dt.filter($event.target.value, col.field, 'contains')">
            <input *ngSwitchCase="'address'" pInputText type="text"
              (input)="dt.filter($event.target.value, col.field, 'contains')">
            <input *ngSwitchCase="'schoolName'" pInputText type="text"
              (input)="dt.filter($event.target.value, col.field, 'contains')">
            <input *ngSwitchCase="'f_annote'" pInputText type="text"
              (input)="dt.filter($event.target.value, col.field, 'contains')">
            <p-calendar [(ngModel)]="dateFilters" dataType="string" dateFormat="mm/dd/yy" appendTo="body"
              *ngSwitchCase="'dateregistered'" selectionMode="range" [readonlyInput]="false" yearrange="1950:2030"
              [numberOfMonths]="3" (onSelect)="dt.filter($event, col.field, 'dateRangeFilter')">
            </p-calendar>
            <p-calendar [(ngModel)]="skipFilters" dataType="string" dateFormat="mm/dd/yy" appendTo="body"
              *ngSwitchCase="'skip_notification'" selectionMode="range" [readonlyInput]="false" yearrange="1950:2030"
              [numberOfMonths]="3" (onSelect)="dt.filter($event, col.field, 'dateRangeFilter')">
            </p-calendar>
            <p-calendar [(ngModel)]="inactiveFilters" dataType="string" dateFormat="mm/dd/yy" appendTo="body"
              *ngSwitchCase="'inactive'" selectionMode="range" [readonlyInput]="false" yearrange="1950:2030"
              [numberOfMonths]="3" (onSelect)="dt.filter($event, col.field, 'dateRangeFilter')">
            </p-calendar>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData">
          <td *ngFor="let col of columns">
            <span
              *ngIf="col.field === 'dateregistered' || col.field === 'skip_notification' || col.field === 'inactive'">{{ rowData[col.field] | date: 'shortDate'  }}</span>
            <span
              *ngIf="col.field !== 'dateregistered' && col.field !== 'skip_notification' && col.field !== 'inactive'">{{rowData[col.field]}}</span>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="summary" let-rowData>
        <div style="text-align:left">
          <button type="button" pButton (click)="showDialogToAdd()" label="Add"></button>
        </div>
      </ng-template>
    </p-table>

    <p-dialog header="Member Details" [(visible)]="displayDialog" [responsive]="true" showEffect="fade" [modal]="true"
      [style]="{width: '500px'}">
      <div class="red-text" *ngIf="errorMessage">{{ errorMessage }}</div>
      <div class="alert-success" *ngIf="successMessage">{{ successMessage }}</div>
      <div class="ui-g ui-fluid" *ngIf="member">
        <div class="ui-g-12">
          <div class="ui-g-4">
            <label for="sourceschool">School</label>
          </div>
          <div class="ui-g-8">
            <p-dropdown id="sourceschool" [options]="schoolsSelect" [(ngModel)]="member.sourceschool"
              (onChange)="onToggleCreateActionInput()"></p-dropdown>
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-4 pad0">
            <label for="membername">UserName*</label>
          </div>
          <div class="ui-g-8 pad0">
            <input pInputText class="margin0" id="membername" [(ngModel)]="member.membername" [disabled]="!newRegmem"
              required />
          </div>
        </div>

        <div class="ui-g-12">
          <div class="ui-g-4 pad0">
            <label for="fname">First Name*</label>
          </div>
          <div class="ui-g-8 pad0">
            <input pInputText class="margin0" id="fname" [(ngModel)]="member.fname" required />
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-4 pad0">
            <label for="memberstate">Last Name</label>
          </div>
          <div class="ui-g-8 pad0">
            <input pInputText class="margin0" id="lname" [(ngModel)]="member.lname" />
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-4 pad0">
            <label for="eaddress">Email*</label>
          </div>
          <div class="ui-g-8 pad0">
            <input pInputText class="margin0" id="eaddress" [(ngModel)]="member.eaddress" required />
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-4 pad0">
            <label for="phone1">Phone*</label>
          </div>
          <div class="ui-g-8 pad0">
            <input pInputText class="margin0" id="phone1" [(ngModel)]="member.phone1" required />
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-4 pad0">
            <label for="address">Address*</label>
          </div>
          <div class="ui-g-8 pad0">
            <input pInputText class="margin0" id="address" [(ngModel)]="member.streetaddress" required />
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-4 pad0">
            <label for="state">State*</label>
          </div>
          <div class="ui-g-8 pad0">
            <input pInputText class="margin0" id="state" [(ngModel)]="member.state" required />
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-4 pad0">
            <label for="city">City*</label>
          </div>
          <div class="ui-g-8 pad0">
            <input pInputText class="margin0" id="city" [(ngModel)]="member.city" required />
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-4 pad0">
            <label for="zipcode">Zip Code*</label>
          </div>
          <div class="ui-g-8 pad0">
            <input pInputText class="margin0" id="zipcode" [(ngModel)]="member.postalcode" required />
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-4 pad0">
            <label for="dateregistered">Registered Date</label>
          </div>
          <div class="ui-g-8 pad0">
            <input pInputText class="margin0" id="dateregistered" [ngModel]="member.dateregistered | date: 'shortDate' "
              (ngModelChange)="member.dateregistered=$event" />
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-4 pad0">
            <label for="inactive">Inactive Since</label>
          </div>
          <div class="ui-g-8 pad0">
            <input pInputText class="margin0" id="inactive" [ngModel]="member.inactive | date: 'shortDate' " />
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-4 pad0">
            <label for="oid">Transaction ID</label>
          </div>
          <div class="ui-g-8 pad0">
            <input pInputText class="margin0" id="oid" [(ngModel)]="member.oid" />
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-4 pad0">
            <label for="skip_notification">Course Skipped Date</label>
          </div>
          <div class="ui-g-8 pad0">
            <label>{{ member.skip_notification  | date: 'shortDate'   }}</label>
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-4 pad0">
            <label for="areaunit">IU</label>
          </div>
          <div class="ui-g-8 pad0">
            <label>{{ memberinfo.areaunit }}</label>
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-4 pad0">
            <label for="lastworkeddate">Last Worked Date</label>
          </div>
          <div class="ui-g-8 pad0">
            <label>{{ memberinfo.lastworkeddate | date: 'shortDate' }}</label>
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-4 pad0">
            <label for="certificate">Certificate</label>
          </div>
          <div class="ui-g-8 pad0">
            <label>{{ memberinfo.certificate }}</label>
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-4 pad0">
            <label for="certificateattempt">Student Progress</label>
          </div>
          <div class="ui-g-8 pad0">
            <button (click)="gotoProgress()">Click Here</button>
          </div>
        </div>


      </div>
      <ng-template pTemplate="footer">
        <div class="ui-dialog-buttonpane ui-helper-clearfix">
          <button type="button" pButton (click)="resetPassword()" label="Reset Password"></button>
          <button type="button" pButton (click)="save()"
            [disabled]="!member.membername || !member.memberstatus || !member.fname || !member.phone1 || !member.eaddress || !member.streetaddress || !member.state || !member.city || !member.postalcode"
            label="Save"></button>
        </div>
      </ng-template>

    </p-dialog>
  </div>
</div>
